import ComposePopoutData from '../store/schema/ComposePopoutData';
import ComposeViewState from '../store/schema/ComposeViewState';
import { AttachmentModel } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import mailTipsCacheStore from 'owa-mail-tips/lib/store/store';
import { action } from 'satcheljs/lib/legacy';

export default function prepareComposeViewStateForPopout(
    viewState: ComposeViewState
): ComposePopoutData {
    preparePopoutCompose(viewState);

    const attachments: AttachmentModel[] = [];

    // Store Attachment information in Local Storage
    if (viewState.attachmentWell) {
        viewState.attachmentWell.docViewAttachments.forEach(element => {
            attachments.push(getAttachment(element.attachmentId));
        });
        viewState.attachmentWell.imageViewAttachments.forEach(element => {
            attachments.push(getAttachment(element.attachmentId));
        });
        viewState.attachmentWell.inlineAttachments.forEach(element => {
            attachments.push(getAttachment(element.attachmentId));
        });
    }

    const mailtips = mailTipsCacheStore.mailTips
        ? mailTipsCacheStore.mailTips.returnAllMailTipsCacheEntries()
        : null;

    return {
        composeViewState: viewState,
        attachments,
        mailtips,
    };
}

const preparePopoutCompose = action('preparePopoutCompose')(function preparePopoutCompose(
    viewState: ComposeViewState
) {
    // Set viewstate popout information.
    viewState.docking.isPopout = true;
    viewState.isPopout = true;
    viewState.preferAsyncSend = false;

    // Don't show subject picker
    viewState.subjectPickerViewState.isPickerOpened = false;
    viewState.subjectPickerViewState.supportsSubjectPicker = false;
});
